"use client"

import type { ReactNode } from "react"

import type { AvatarProps as UUIAvatarProps } from "@/components/ui-kit/untitled/base/avatar/avatar"
import { AvatarLabelGroup as UUIAvatarLabelGroup } from "@/components/ui-kit/untitled/base/avatar/avatar-label-group"

import { identityPlaceholder } from "./avatar"

/**
 * App-wide identity avatar with title/subtitle labels. Same contract as
 * `Avatar` — `name` plus an optional `avatar_url` — with the deterministic
 * boring-avatars beam as the fallback when no uploaded avatar is available.
 * Delegates layout and typography to the UUI AvatarLabelGroup.
 */

export interface AvatarLabelGroupProps
  extends Pick<UUIAvatarProps, "className" | "status"> {
  size: "sm" | "md" | "lg" | "xl"
  /** Display name — used as alt text and as the deterministic boring-avatars seed. */
  name: string
  /** Server-shipped avatar URL (e.g. `user.avatar_url`). */
  avatarUrl?: string | null
  title: string | ReactNode
  subtitle: string | ReactNode
}

export function AvatarLabelGroup({
  name,
  avatarUrl,
  size,
  ...rest
}: AvatarLabelGroupProps) {
  return (
    <UUIAvatarLabelGroup
      src={avatarUrl ?? undefined}
      alt={name}
      size={size}
      placeholder={identityPlaceholder(name, size)}
      {...rest}
    />
  )
}
